import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import QueryListFiles from 'graphQL/content/listFiles'
import QueryGetUploadURL from 'graphQL/asset/getUploadUrl'
import MutationCreateFile from 'graphQL/content/createFile'
import MutationCreateFolder from 'graphQL/content/createFolder'
import QueryListFolders from 'graphQL/content/listFolders'
import MutationUpdateFolder from 'graphQL/content/updateFolder'
import MutationDeleteFolders from 'graphQL/content/deleteFolders'

// for listing files
export const useListFiles = (options) => {
  return useQuery(QueryListFiles, options)
}

export const useGetUploadURL = (options) => {
  return useLazyQuery(QueryGetUploadURL, options)
}

// for listing folders inside lotte, json etcc folder
export const useListFolders = (options) => {
  return useQuery(QueryListFolders, options)
}

export const useCreateFile = (options) => {
  return useMutation(MutationCreateFile, options)
}

// create folder inside lotte, json etcc folder
export const useCreateFolder = (options) => {
  return useMutation(MutationCreateFolder, options)
}

export const useUpdateFolder = (options) => {
  return useMutation(MutationUpdateFolder, options)
}

export const useDeleteFolder = (options) => {
  return useMutation(MutationDeleteFolders, options)
}
